__turbopack_context__.v({
  "PersonCardSliderSection": "PersonCardSliderSection-module-scss-module__EyrZkq__PersonCardSliderSection",
  "prev__arrow": "PersonCardSliderSection-module-scss-module__EyrZkq__prev__arrow",
});
